import * as React from "react"
import { type VTableLoadingProps } from "@digits-shared/components/UI/VirtualizedTable/vTableTypes"
import { Tbody, Td, Tr } from "@digits-shared/DesignSystem/Tables/tableStyles"
import { type CellContext, flexRender } from "@tanstack/react-table"

/*
  COMPONENTS
*/
export const VTableLoading = <TData extends object>({
  table,
  rowCount,
}: VTableLoadingProps<TData>) => {
  const rows = Array.from({ length: rowCount || 15 })
  const columns = table.getAllLeafColumns()

  return (
    <Tbody inert>
      {rows.map((_, index) => (
        <Tr key={index} className="disabled">
          {columns.map((column) => (
            <Td key={column.id}>
              {flexRender(column.columnDef.cell, {
                table,
                column,
                row: {
                  id: `loading-${index}`,
                  index,
                },
                cell: {
                  id: `${column.id}-${index}`,
                  column,
                },
              } as CellContext<TData, unknown>)}
            </Td>
          ))}
        </Tr>
      ))}
    </Tbody>
  )
}
